(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bundle-v2').forEach(initBundle);
  });

  // Kaching Cart (the slide-cart used everywhere else on the site) watches for
  // /cart/add requests and opens itself — its "shouldOpenCartDrawerOnAddToCart"
  // setting is on. Detect a live instance so we only fall back to the /cart page
  // when the app is genuinely not going to handle it, and the shopper always
  // gets some feedback after adding.
  function kachingSlideCartActive() {
    try {
      if (window.__kachingCartDisabled === true) return false;
      if (window.__kachingCartFailedModuleLoad === true) return false;
      return !!document.querySelector('kaching-cart');
    } catch (e) {
      return false;
    }
  }

  function initBundle(section) {
    var subArea = section.querySelector('[data-area="subscription"]');
    var otArea = section.querySelector('[data-area="onetime"]');
    var toggle = section.querySelector('.bundle-v2__toggle');
    var toggleText = toggle ? toggle.querySelector('.bundle-v2__toggle-text') : null;
    var atcBtn = section.querySelector('.bundle-v2__atc');
    var errorEl = section.querySelector('.bundle-v2__error');
    var atcOriginalHTML = atcBtn ? atcBtn.innerHTML : '';

    // Ensure default active cards in each area
    [subArea, otArea].forEach(function (area) {
      if (!area) return;
      if (!area.querySelector('.bundle-v2__card--active')) {
        var first = area.querySelector('.bundle-v2__card');
        if (first) first.classList.add('bundle-v2__card--active');
      }
    });

    // Card selection
    section.querySelectorAll('.bundle-v2__card').forEach(function (card) {
      card.addEventListener('click', function () {
        var area = card.closest('[data-area]');
        area.querySelectorAll('.bundle-v2__card').forEach(function (c) {
          c.classList.remove('bundle-v2__card--active');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('bundle-v2__card--active');
        card.setAttribute('aria-checked', 'true');
      });

      // Keyboard support
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    // Toggle between subscription and one-time
    if (toggle) {
      toggle.addEventListener('click', function () {
        var subHidden = subArea.classList.contains('bundle-v2__area--hidden');

        if (subHidden) {
          // Switch to subscription view
          subArea.classList.remove('bundle-v2__area--hidden');
          otArea.classList.add('bundle-v2__area--hidden');
          toggleText.textContent = toggle.dataset.toggleToOt;
        } else {
          // Switch to one-time view
          otArea.classList.remove('bundle-v2__area--hidden');
          subArea.classList.add('bundle-v2__area--hidden');
          toggleText.textContent = toggle.dataset.toggleToSub;
        }
      });
    }

    // Add to Cart
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var visibleArea = section.querySelector('[data-area]:not(.bundle-v2__area--hidden)');
        if (!visibleArea) return;

        var activeCard = visibleArea.querySelector('.bundle-v2__card--active');
        if (!activeCard) return;

        var variantId = activeCard.dataset.variantId;
        var sellingPlanId = activeCard.dataset.sellingPlanId;

        if (!variantId) return;

        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
        errorEl.style.display = 'none';

        var body = {
          id: parseInt(variantId, 10),
          quantity: 1
        };

        if (sellingPlanId) {
          body.selling_plan = parseInt(sellingPlanId, 10);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error(data.description || 'Could not add to cart');
              });
            }
            if (kachingSlideCartActive()) {
              // Let the slide-cart take over; restore the button behind it.
              atcBtn.disabled = false;
              atcBtn.innerHTML = atcOriginalHTML;
              return;
            }
            window.location.href = '/cart';
          })
          .catch(function (err) {
            errorEl.textContent = err.message;
            errorEl.style.display = 'block';
            atcBtn.disabled = false;
            atcBtn.innerHTML = atcOriginalHTML;
          });
      });
    }
  }
})();
